
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vets",
      function () {
        return require("private-next-pages/vets.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vets"])
      });
    }
  